var _ellipse, _circle, _ellipse2, _ellipse3, _ellipse4, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 170,
    viewBox: "0 0 278 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 78,
    cy: 139,
    rx: 65,
    ry: 64,
    fill: "#0F5EFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 172,
    cy: 54,
    r: 64,
    fill: "#0F5EFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 59,
    cy: 30.5,
    rx: 9,
    ry: 8.5,
    fill: "#0F5EFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 9,
    cy: 8.5,
    rx: 9,
    ry: 8.5,
    transform: "matrix(-1 0 0 1 278 77)",
    fill: "#0F5EFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 52.5,
    cy: 37,
    rx: 4.5,
    ry: 5,
    fill: "#0F5EFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 265 100)",
    fill: "#0F5EFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 64,
    cy: 146,
    r: 63.5,
    stroke: "#0F5EFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 192,
    cy: 37,
    r: 63.5,
    stroke: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseicon);
export default __webpack_public_path__ + "static/media/eclipseicon.85103de9ac2e3542b756bb2d9fd557dd.svg";
export { ForwardRef as ReactComponent };